/* eslint-disable no-underscore-dangle */
export default (url, cid) => (window.__POWERED_BY_QIANKUN__ ? `${window.location.origin}/customer_switch/${cid}/?next=${url}` : `${window.location.origin}${url}`);
